module.exports = __webpack_public_path__ + "img/0Q3A5746_L_BlackMatted_MockedUp.611e8d12.jpg";